module.exports = __webpack_public_path__ + "assets/game-type-conversation.9665c5ff.svg";